import { render, staticRenderFns } from "./formbuilderTemplateDataList.vue?vue&type=template&id=5a40cf68&scoped=true"
import script from "./formbuilderTemplateDataList.vue?vue&type=script&lang=js"
export * from "./formbuilderTemplateDataList.vue?vue&type=script&lang=js"
import style0 from "./formbuilderTemplateDataList.vue?vue&type=style&index=0&id=5a40cf68&prod&lang=scss&scoped=true"
import style1 from "./formbuilderTemplateDataList.vue?vue&type=style&index=1&id=5a40cf68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a40cf68",
  null
  
)

export default component.exports